import { Service } from '@angular/core';

@Service()
export class ScrollService {
  async scrollIntoViewAsync(container: HTMLElement | null | undefined, target: HTMLElement | null | undefined, behavior: ScrollBehavior = 'smooth', delay = 0): Promise<void> {
    await new Promise<void>(resolve => setTimeout(resolve, delay));
    if (!container || !target) return;
    const containerRect = container.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    const newScrollTop = container.scrollTop + (targetRect.top - containerRect.top);
    container.scrollTo({ top: newScrollTop, behavior });
  }
}
